
import React from 'react';
import { GripHorizontal } from 'lucide-react';

export const GrabHandleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <GripHorizontal strokeWidth={1.5} {...props} />
);
